import Login from "./AuthPages/Login/Index";
import Otp from "./AuthPages/Otp/Index";
import ForgotPassword from "./AuthPages/forgotPassword/Index";
import ResetPassword from "./AuthPages/resetPassword/Index";
import Accounting from "./SideTabPages/Accounting";
import ContentPage from "./SideTabPages/ContentPages";
import AddContentPage from "./SideTabPages/ContentPages/add";
import ViewContentPage from "./SideTabPages/ContentPages/detail";
import Dashboard from "./SideTabPages/Dashboard";
import Earnings from "./SideTabPages/Earnings";
import Faq from "./SideTabPages/Faq";
import AddFaq from "./SideTabPages/Faq/add";
import Help from "./SideTabPages/Help";
import HelpDetail from "./SideTabPages/Help/detail";
import ManageCommssions from "./SideTabPages/ManageCommissions";
import ManageService from "./SideTabPages/ManageService";
import AddEditService from "./SideTabPages/ManageService/Add";
import ManageServiceDetail from "./SideTabPages/ManageService/Detail";
import ManageQuestion from "./SideTabPages/ManageQuestions";
import AddEditQuestion from "./SideTabPages/ManageQuestions/Add";
import ManageQuestionDetail from "./SideTabPages/ManageQuestions/Detail";
import ManageServiceCategory from "./SideTabPages/ManageServiceCategory";

import AddEditServiceCategory from "./SideTabPages/ManageServiceCategory/Add";
import ManageServiceDetailCatgeory from "./SideTabPages/ManageServiceCategory/Detail";
import ServiceProviderRequest from "./SideTabPages/ManageServiceProvider/NewRequest";
import RegisterServiceProvider from "./SideTabPages/ManageServiceProvider/Register";
import AddNewServiceProvider from "./SideTabPages/ManageServiceProvider/Register/Add";
import ServiceProviderDetail from "./SideTabPages/ManageServiceProvider/detail";
import ManageUser from "./SideTabPages/ManageUser";
import AddEditUser from "./SideTabPages/ManageUser/Add";
import UserDetail from "./SideTabPages/ManageUser/detail";
import Notification from "./SideTabPages/Notification";
import AddNotification from "./SideTabPages/Notification/add";
import OrderManagement from "./SideTabPages/OrderManagement";
import OrderDetail from "./SideTabPages/OrderManagement/Detail";
import Promocode from "./SideTabPages/Promocode";
import AddPromoCode from "./SideTabPages/Promocode/add";
import PromoCodeDetail from "./SideTabPages/Promocode/detail";
import PromotionList from "./SideTabPages/Promotion";
import AddPromotion from "./SideTabPages/Promotion/add";
import Refund from "./SideTabPages/Refund";
import RefundDetail from "./SideTabPages/Refund/detail";
import Settings from "./SideTabPages/Settings";
import EditProfile from "./SideTabPages/Settings/EditProfile";
import ManagePassword from "./SideTabPages/Settings/ManagePassword";
import BasicSettings from "./SideTabPages/Settings/Profile/BasicSettings";
import SystemAccess from "./SideTabPages/SystemAccess";
import AddSubAdmin from "./SideTabPages/SystemAccess/add";
import ManageSubscription from "./SideTabPages/ManageSubscription";
import SubscriptionAdd from "./SideTabPages/ManageSubscription/Add";
import ViewSubscription from "./SideTabPages/ManageSubscription/View";
import SignUpQuestionList from "./SideTabPages/SignUpQuestion";
import AddSignUpQuestion from "./SideTabPages/SignUpQuestion/Add";
import CategoryRequestData from "./SideTabPages/CategoryRquest";
import CategoryRequestDetails from "./SideTabPages/CategoryRquest/Detail";

import Report from "./SideTabPages/Report";
import AddReport from "./SideTabPages/Report/add";
import ReportDetail from "./SideTabPages/Report/detail";
import Reported from "./SideTabPages/Reported";

export const routes = [
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgotPassword /> },
  { path: "/otp", component: <Otp /> },
  { path: "/reset-password/:id", component: <ResetPassword /> },
];

export const privateRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/manage-user", component: <ManageUser /> },
  { path: "/manage-user/add", component: <AddEditUser /> },
  { path: "/manage-user/edit/:id", component: <AddEditUser /> },
  { path: "/manage-user/detail/:id", component: <UserDetail /> },
    // { path: "/reset-password/:id", component: <ResetPassword /> },

  {
    path: "/service-provider/register",
    component: <RegisterServiceProvider />,
  },
  {
    path: "/service-provider/register/add",
    component: <AddNewServiceProvider />,
  },
  {
    path: "/service-provider/register/edit/:id",
    component: <AddNewServiceProvider />,
  },
  {
    path: "/service-provider/register/detail/:id",
    component: <ServiceProviderDetail />,
  },
  {
    path: "/service-provider/request/detail/:id",
    component: <ServiceProviderDetail />,
  },
  {
    path: "/service-provider/request",
    component: <ServiceProviderRequest />,
  },

  // Signup questions
  {
    path: "/signupquestion",
    component: <SignUpQuestionList />,
  },
  {
    path: "/signupquestion/add",
    component: <AddSignUpQuestion />,
  },
  {
    path: "/signupquestion/edit/:id",
    component: <AddSignUpQuestion />,
  },
  // Category Request
  {
    path: "/categoryrequest",
    component: <CategoryRequestData />,
  },
  {
    path: "/categoryrequest/detail/:id",
    component: <CategoryRequestDetails />,
  },
  {
    path: "/order-management",
    component: <OrderManagement />,
  },
  {
    path: "/order-management/detail/:id",
    component: <OrderDetail />,
  },
  {
    path: "/manage-service-category",
    component: <ManageServiceCategory />,
  },
  {
    path: "/manage-service-category/detail/:id",
    component: <ManageServiceDetailCatgeory />,
  },
  {
    path: "/manage-service-category/add",
    component: <AddEditServiceCategory />,
  },
  {
    path: "/manage-service-category/edit/:id",
    component: <AddEditServiceCategory />,
  },
  {
    path: "/manage-commissions",
    component: <ManageCommssions />,
  },
  {
    path: "/earnings",
    component: <Earnings />,
  },
  {
    path: "/report",
    component: <Report />,
  },
  {
    path: "/report/add",
    component: <AddReport />,
  },
  {
    path: "/report/edit/:id",
    component: <AddReport />,
  },
  {
    path: "/report/detail/:id",
    component: <ReportDetail />,
  },
  {
    path: "/accounting",
    component: <Accounting />,
  },
  {
    path: "/refund",
    component: <Refund />,
  },

  { path: "/subscription", component: <ManageSubscription /> },
  { path: "/subscription/add", component: <SubscriptionAdd /> },
  { path: "/subscription/edit/:id", component: <SubscriptionAdd /> },
  { path: "/subscription/view/:id", component: <ViewSubscription /> },
  {
    path: "/refund/detail",
    component: <RefundDetail />,
  },
  {
    path: "/promocode",
    component: <Promocode />,
  },
  {
    path: "/promocode/add",
    component: <AddPromoCode />,
  },
  {
    path: "/promocode/edit/:id",
    component: <AddPromoCode />,
  },
  {
    path: "/promocode/detail/:id",
    component: <PromoCodeDetail />,
  },

  // { path: "/manage-user/detail/:id", component: <UserDetail /> },

  {
    path: "/help",
    component: <Help />,
  },
   {
    path: "/reported",
    component: <Reported />,
  },
  {
    path: "/help/detail",
    component: <HelpDetail />,
  },
  {
    path: "/system-access",
    component: <SystemAccess />,
  },
  {
    path: "/system-access/add",
    component: <AddSubAdmin />,
  },
  {
    path: "/system-access/edit/:id",
    component: <AddSubAdmin />,
  },

  {
    path: "/settings",
    component: <Settings />,
  },
  {
    path: "/settings/edit-profile",
    component: <EditProfile />,
  },
  {
    path: "/settings/password",
    component: <ManagePassword />,
  },
  {
    path: "/faq",
    component: <Faq />,
  },
  {
    path: "/faq/add",
    component: <AddFaq />,
  },
  {
    path: "/faq/edit/:id",
    component: <AddFaq />,
  },
  {
    path: "/content-page",
    component: <ContentPage />,
  },
  {
    path: "/content-page/add",
    component: <AddContentPage />,
  },
  {
    path: "/content-page/edit/:id",
    component: <AddContentPage />,
  },
  {
    path: "/content-page/view/:id",
    component: <ViewContentPage />,
  },
  {
    path: "/add-promotion",
    component: <AddPromotion />,
  },
  {
    path: "/promotion",
    component: <PromotionList />,
  },
  {
    path: "/edit-promotion/:id",
    component: <AddPromotion />,
  },
  {
    path: "/basic-settings",
    component: <BasicSettings />,
  },
  {
    path: "/notification",
    component: <Notification />,
  },
  {
    path: "/notification/add",
    component: <AddNotification />,
  },
  {
    path: "/notification/edit/:id",
    component: <AddNotification />,
  },
  {
    path: "/manage-service",
    component: <ManageService />,
  },
  {
    path: "/manage-service/detail/:id",
    component: <ManageServiceDetail />,
  },
  {
    path: "/manage-service/add/:category",
    component: <AddEditService />,
  },
  {
    path: "/manage-service/edit/:id/:category",
    component: <AddEditService />,
  },
  {
    path: "/question",
    component: <ManageQuestion />,
  },
  {
    path: "/question/detail/:id",
    component: <ManageQuestionDetail />,
  },
  {
    path: "/question/add/:category",
    component: <AddEditQuestion />,
  },
  {
    path: "/question/edit/:id/:category",
    component: <AddEditQuestion />,
  },
];
